import { Typography, message } from 'antd';
import { ReactElement } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import useAuth from '../hooks/useAuth';

const { Text } = Typography;

const Content = (): ReactElement => {
  const { login } = useAuth();

  return (
    <>
      <Text type='secondary'>Google Workspaceアカウントでログインしてください</Text>

      <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '24px' }}>
        <GoogleLogin
          onSuccess={async credentialResponse => {
            if (credentialResponse.credential) {
              try {
                await login(credentialResponse.credential);
              } catch (error) {
                console.error('Login error:', error);
                message.error('ログインに失敗しました。もう一度お試しください。');
              }
            }
          }}
          onError={() => {
            console.error('Google Sign-In error');
            message.error('Google Sign-Inに失敗しました。もう一度お試しください。');
          }}
          theme='outline'
          size='large'
          text='signin_with'
          width='300'
        />
      </div>
    </>
  );
};

export default Content;
